import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Text, 
  TableContainer,Table,Thead,Tbody,Th,Tr,Td,Grid,GridItem } from "@chakra-ui/react";
import { TopDisplay } from "../../../../components";
import { IoMdAdd as AddIcon } from "react-icons/io";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState,useEffect } from "react";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import styled from "@emotion/styled";
import { atom, useAtom } from 'jotai';
import apiCall from '../../../../utils/apiCall';
import {TopLink} from '../';
import {openAtom,modalAtom,openNAtom,notificationAtom} from '../../../../context';
import { Formik,Form,Field } from "formik";
import {TablePopUp} from '../../../../components';
import * as Yup from 'yup';
import { Loader } from "../../../../customs";
import ReactPaginate from 'react-paginate';
import { TbReload as ReloadIcon } from "react-icons/tb";
// const allExamSubject = [
//   {
//     Id:Math.floor(Math.random() * 10000)+1,
//     ExamId:'12345',
//     SubjectName:'Internet of things',
//     Level:'2',
//     CutOffMark: '50',
//     Amount:'300,000'
//   },
//   {
//     Id:Math.floor(Math.random() * 10000)+1,
//     ExamId:'12345',
//     SubjectName:'Internet of things',
//     Level:'2',
//     CutOffMark: '50',
//     Amount:'300,000'
//   },
//   {
//     Id:Math.floor(Math.random() * 10000)+1,
//     ExamId:'12345',
//     SubjectName:'Internet of things',
//     Level:'2',
//     CutOffMark: '50',
//     Amount:'300,000'
//   } ,
//   {
//     Id:Math.floor(Math.random() * 10000)+1,
//     ExamId:'12345',
//     SubjectName:'Internet of things',
//     Level:'2',
//     CutOffMark: '50',
//     Amount:'300,000'
//   },
//   {
//     Id:Math.floor(Math.random() * 10000)+1,
//     ExamId:'12345',
//     SubjectName:'Internet of things',
//     Level:'2',
//     CutOffMark: '50',
//     Amount:'300,000'
//   }  
// ]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type > *{
    display:none;
  }
  :hover > td{
    background-color:var(--table-highlight);
    &:last-of-type > *{
      display:block;
    }
  } 
  &.active > td:last-of-type > *{
    display:block !important;
  }  
`

// const allLevel = [
//   {
//     Id:1,
//     Name:"1"
//   },
//   {
//     Id:2,
//     Name:'2'
//   },
//   {
//     Id:3,
//     Name:'3'
//   },
//   {
//     Id:4,
//     Name:'4'
//   }
// ]

const ExamSubjectAtom = atom<number | null>(null);


export default function ExamSubject() {
  const [hide,set_hide] = useState<boolean>(true);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_open] = useAtom(openAtom);
  const [active] = useAtom<number | string | null>(ExamSubjectAtom);
  const [filter_data,set_filter_data] = useState<any>([]);
  const [selected_level,set_selected_level] = useState(null);

  const {data:allLevels} = useQuery(['exam-level'],{
    queryFn:async ()=> await apiCall().get(`/SetUp/GetAllExemption`),
    select(data){
      return data.data.Data;
    }
  })


  const {isLoading,data:allExamSubject} = useQuery(['exam-subject'],{
    queryFn:async ()=> await apiCall().get(`/exam/setup/examSubject`),
    select(data){
      return data.data.Data;
    }
  })
  
  const [search,set_search] = useState('');

  const handleAddSubject = () =>{
    set_modal({
      header:'Exam subject Setup',
      content:<AddType />
    })
    set_open(true);
}

const handleSelected = (e: any) => {
  let val = e.target.value;
 // console.log(val, 'level');

  if (val && allExamSubject) {
    set_filter_data(allExamSubject.filter((eSubject: any) => eSubject.LevelId == val));
    
  } else {
    set_filter_data(allExamSubject);
  }

}
useEffect(()=>{
  set_filter_data(allExamSubject)
  },  [allExamSubject])

  const handleSearch = (e:any)=>{
    let val = e.target.value;
    set_search(val);
    if(val){
      let new_data = filter_data?.filter((eData:any) => Object.values(eData).join(allExamSubject).toLowerCase().includes(val.toLowerCase()) );
      if(new_data.length > 0)set_filter_data(new_data)
      else set_filter_data('')
    }
    else set_filter_data(allExamSubject)
  }

  const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  //console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);
  const handlePageClick = (event:any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };
  useEffect(()=>{
    if(selected_level){
      let data = allLevels.filter((eData:any) => eData.Status === selected_level);
      if(data.length > 0){
        set_filter_data(data);
      }
    }
    else{
      set_filter_data(allLevels);
    }
  },[selected_level])

  useEffect(()=>{
    set_filter_data(allExamSubject)
  },[allExamSubject])


  return (
    <>
    {isLoading?<Loader />:
    <Box>
      <TopLink />
      <TopDisplay label="Exam Subject" button_array={[
          <Button onClick={handleAddSubject} bg="var(--dark-green-color)" color="var(--white-color)"  type="button"  leftIcon={<AddIcon/>}>Add Subjects</Button>
        ]} />
        <Flex  gap="20px" wrap="wrap" mt="20px">
          <InputGroup width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
            <InputLeftElement pointerEvents='none'>
              <SearchIcon color='gray.300' />
            </InputLeftElement>
            <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
            <span style={{position:'absolute',zIndex:'1',
            right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
          </InputGroup>
          <Select placeholder="Level" width="100px" bg="var(--white-color)" 
            borderColor="var(dark-green-color)" onChange={handleSelected}>
              {allLevels && allLevels.length > 0 ? 
              allLevels.map((eLevel:any) => <option key={eLevel.Id} value={eLevel.Id}>
                {eLevel.Name}
              </option>):''}
          </Select>
          

        </Flex>
        <Flex mt="25px" flexDir="column" gap="10px">
          <Text m="0" fontSize=".8rem">showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
        </Flex>
     {   filter_data && filter_data.length > 0 ? <TableContainer mt="20px">
          <Table size='sm'>
            <Thead>
              <Tr >
                {/* <Th sx={HeadStyle}>Exam ID</Th> */}
                <Th sx={HeadStyle}>Subject Name</Th>
                <Th sx={HeadStyle}>Level</Th>
                <Th sx={HeadStyle}>Cut-Off Mark</Th>
                {/* <Th sx={HeadStyle}>Amount</Th> */}
                <Th sx={HeadStyle} w="50px"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.map((eExamSuject:any) =><ROWSTYLE key={eExamSuject.Id} className={eExamSuject.Id === active?'active':''}>
                {/* <Td sx={DataStyle}>{eExamSuject.Id}</Td> */}
                <Td sx={DataStyle}>{eExamSuject.Name}</Td>
                <Td sx={DataStyle}>{eExamSuject.Level?eExamSuject.Level.ExemptionName:''}</Td>
                <Td sx={DataStyle}>{eExamSuject.CutOffMark}</Td>
                {/* <Td sx={DataStyle}>{eExamSuject.Amount}</Td> */}
                <Td sx={DataStyle} w="50px" h="50px">
                  <TempPopUp index={eExamSuject.Id} data={eExamSuject}/>
                </Td>
              </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :'No Subject'  
      }
      <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

       </StylePaginateBox>
    </Box>
    }
    </>
    
  )
}
const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`
// function set_modal(arg0: { header: string; content: import("react/jsx-runtime").JSX.Element; }) {
//   throw new Error("Function not implemented.");
// }

// function set_open(arg0: boolean) {
//   throw new Error("Function not implemented.");
// }

const AddSchema = Yup.object({
  Name:Yup.string().required(),
  LevelId:Yup.number().required(),
  CutOffMark:Yup.number().required(),
  Amount:Yup.number().required(),
  SubjectCode:Yup.string().required(),
});

const AddType = (props:any) =>{
  const queryClient = useQueryClient();
  const [,set_open] = useAtom(openAtom);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);
  const {data:allLevel} = useQuery(['exam-level'],{
    queryFn:async ()=> await apiCall().get(`/SetUp/GetAllExemption`),
    select(data){
      return data.data.Data;
    }
  })

  const {mutate:addUpdate,isLoading} = useMutation({
    mutationKey:['new-exam-subject'],
    mutationFn:async (data:any)=> {
      return props && props.Id?await apiCall().put(`/exam/setup/examSubject/${props.Id}`,data):await apiCall().post(`/exam/setup/examSubject`,data)},
    onSuccess:(data)=>{
      console.log(data,'new data')
      set_notification({
        type:'success',
        message:data?.data?.Message || 'Added Successfully'
      })
      set_Nopen(true);
      queryClient.invalidateQueries({
        queryKey:['exam-subject']
      });
    },
    onError(error:any){
      set_notification({
        type:'error',
        message:error?.data?.Message || 'Error Occured'
      })
      set_Nopen(true);
    },
    onSettled:()=>{
      set_open(false);
    }
  })

  return (
    <Formik
          initialValues={{
            Name:props.Name || '',
            LevelId:props.LevelId || '',
            CutOffMark: props.CutOffMark || '',
            Amount :props.Amount || '',
            SubjectCode:props.SubjectCode || '',
          }}
          validationSchema={AddSchema}
          onSubmit={(values:any) => {
            console.log('clicked')
            const data = {
              Name:values.Name,
              LevelId:Number(values.LevelId || 0),
              CutOffmark:values.CutOffMark,
              Amount:values.Amount,
              SubjectCode:values.SubjectCode,
              
            };
            // console.log(data,'form data')

            addUpdate(data);
          }}
        >
         {(formik:any)=>{
        const {errors,values} = formik;
        // console.log(values,'values');
        // console.log(errors,'errors')
        return (
            <Form>
              <Flex flexDir={"column"} align={"center"} gap="20px">
                <Input as={Field} 
                  placeholder="Subject Name"
                  name="Name"
                  type="text"
                />
                
                <Field as={Select}
                  bg='var(--white-color)'
                  borderColor='var(--dark-green-color)'
                  color='var(--dark-green-color)'
                  placeholder='Select Level'
                  name="LevelId"
                >
                  {allLevel && allLevel.length > 0 ?
                    allLevel.map((eType:any) => <option key={eType.Id} value={eType.Id}>{eType.Name}</option>)
                  :''}
                </Field>
                <Input as={Field}
                  placeholder="CutOffMark"
                  size="md"
                  name="CutOffMark"
                  type="number"
                  inputMode="numeric"
                />
              
                 {/* <Input as={Field} 
                  placeholder="Amount"
                  name="Amount"
                  type="number"
                /> */}
                 <Input as={Field} 
                  placeholder="Subject Code"
                  name="SubjectCode"
                  type="type"
                />
                
                <Button disabled={isLoading} type="submit" bg="var(--dark-green-color)" color="var(--white-color)" >
                  {isLoading?"Loading":'Submit'}
                </Button>
              </Flex>
                
              
            </Form>
          )}}
        </Formik>
  )

}

const TempPopUp = (props:any) =>{
  const index = props.index;
  const data = props.data;
  const [active,set_active] = useAtom(ExamSubjectAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);
  const queryClient = useQueryClient();
  const {mutate:deleteFee,isLoading} = useMutation({
    mutationKey:['delete-exam-subject'],
    mutationFn:async () => await apiCall().get(`/exam/setup/examSubject/${data?.Id}/delete`),
    onSuccess(data:any) {
      queryClient.invalidateQueries({queryKey:["exam-subject"]})
      set_notification({
        type:'success',
        message:data?.data?.Message || 'Deleted Successfully'
      })
      set_Nopen(true);
    },
    onSettled(){
      set_open(false);
    }
  })

  const handleClick = () =>{
    if(index === active){
      set_active(null);
      return;
    }
    else{
      set_active(index);
    }
  }
  const handleView= () =>{
    set_modal({
      header:'View Subect SetUp',
      content:<Grid>
        <GridItem justify="space-between" p="10px 0" as={Flex}>
          {/* <span>Subject Id</span>
          <span>{data?.Id}</span> */}
        </GridItem >
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>Subject Name:</span>
          <span>{data?.Name}</span>
        </GridItem>
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>Subject Level</span>
          <span>{data?.Level?data?.Level.ExemptionName:''}</span>
        </GridItem>
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>Subject Cut Off Mark</span>
          <span>{data?.CutOffMark}</span>
        </GridItem>
        {/* <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>Amount</span>
          <span>{data?.Amount}</span>
        </GridItem> */}
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>Subject Code</span>
          <span>{data?.SubjectCode}</span>
        </GridItem>
      </Grid>
    })
    set_open(true);
    handleClick();
  }
  const handleEdit = () =>{
    handleClick();
    set_modal({
      header:'Edit Subject SetUp',
      content:<AddType {...data}/>
    });
    set_open(true);
    handleClick();
    
  }
  const handleDelete = () =>{
    set_modal({
      header:'Delete Subject SetUp',
      content:<Grid gap="20px">
        <GridItem>Are you Sure you want to delete this Subject</GridItem>
        <GridItem as={Flex} justify="space-between" p="20px 0">
          <Button disabled={isLoading} onClick={()=>deleteFee()} bg="var(--dark-green-color)"
            color="var(--white-color)" >{isLoading?'Loading':'Delete'}</Button>
          <Button disabled={isLoading} 
            variant="outline" bg="var(--white-color)"
            onClick={()=>set_open(false)}
            border="1px solid var(--dark-green-color)"
            color="var(--dark-green-color)" >Cancel</Button>
        </GridItem>
      </Grid>
    });
    set_open(true);
  }
  
  return (
    <TablePopUp click={handleClick} options={[
      {label:'View Subject SetUp',click:handleView},
      {label:'Edit Subject SetUp',click:handleEdit},
      {label:'Delete Subject SetUp',click:handleDelete}
    ]} />
  )
}

function set_filter_data(allExamSubject: any) {
  throw new Error("Function not implemented.");
}

function f(val: any) {
  throw new Error("Function not implemented.");
}

